import * as coreSelectors from './selectors/core';

export const selectors = {
  ...coreSelectors,
};
